import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLargeToast } from "../../../redux/actions/toastNotification/toastNotification";
import { RootState } from "../../../redux/reducers/root";
import AmpButton from "../AmpButton/AmpButton";

import "./PopUpToast.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

export default function PopUpToast() {

    const popUpToastStore = useSelector((state: RootState) => state.toastifyReducer.popupToastReducer);

    const { t } = useTranslation("login");

    const dispatch = useDispatch();

    const onConfirm = () => {
        dispatch(setLargeToast("", "success", false));
    }

    return (
        <>
            {popUpToastStore.show ? (
                <div className="popup-top">
                    <div className="popup-container">
                        <div className="toast-header"></div>
                        <div className="toast-content">
                            <h3>{popUpToastStore.message}</h3>
                            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                            </svg>
                            {popUpToastStore.type === "error" && (
                                <div className="xmark">
                                    <FontAwesomeIcon icon={faCircleXmark} size="5x" />
                                </div>
                            )}
                            <AmpButton atlStyle onClick={(e) => onConfirm()} type={"cancel"} text={t("close")} />
                        </div>
                    </div>
                </div>
            ) : <></>}
        </>
    )
}